import { AppNS } from 'app';

import { request } from '../config';

const URL = 'inspector-profiles';

export function apiSetProfile(): Promise<string> {
  return request(
    {
      url: `${URL}.json`,
      method: 'POST',
      data: {},
    },
    (data) => {
      return data.model.id;
    }
  );
}

export function apiGetProfile(id: string, signal?: AbortSignal): Promise<AppNS.InspectorProfile> {
  return request(
    {
      url: `${URL}/${id}.json`,
      method: 'GET',
      signal,
    },

    (data) => {
      return data.model;
    }
  );
}

export function apiGetProfiles(opts: AppNS.Params = {}, signal?: AbortSignal): Promise<AppNS.InspectorProfile[]> {
  return request(
    {
      url: `${URL}.json`,
      method: 'GET',
      signal,
      params: {
        ...opts,
      },
    },

    (data) => {
      return data.models.results;
    }
  );
}

export function apiUpdateProfile(
  profileId: string,
  data: Partial<AppNS.InspectorProfile>
): Promise<AppNS.InspectorProfile> {
  return request(
    {
      url: `${URL}/${profileId}.json`,
      method: 'PATCH',
      data: {
        inspector_profile: {
          ...data,
        },
      },
    },
    (data) => {
      return data.model;
    }
  );
}

export function apiUpdateProfileState(
  profileId: string,
  state: AppNS.InspectorProfileState
): Promise<AppNS.InspectorProfile> {
  return request(
    {
      url: `${URL}/${profileId}/update-state.json`,
      method: 'PATCH',
      data: {
        inspector_profile: {
          state,
        },
      },
    },
    (data) => {
      return data.model;
    }
  );
}
